// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12fM1","buttons":"Footer_buttons__3gjB_"};